import { Plan_Type_Enum } from 'types/databaseEnums';

const STORAGE_KEY = 'bds_plan_preference';
const TTL_MS = 30 * 60 * 1000; // 30 minutes

const PLAN_SLUG_MAP: Record<string, Plan_Type_Enum> = {
  monthly: Plan_Type_Enum.Monthly,
  yearly: Plan_Type_Enum.Yearly,
  lifetime: Plan_Type_Enum.Lifetime,
};

export const savePlanPreference = (slug: string) => {
  const plan = PLAN_SLUG_MAP[slug.toLowerCase()];
  if (!plan) return;

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ plan, ts: Date.now() }));
  } catch {
    // QuotaExceeded or SecurityError — silently ignore
  }
};

export const getPlanPreference = (): Plan_Type_Enum | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;

    const { plan, ts } = JSON.parse(raw);
    if (Date.now() - ts > TTL_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }

    // Validate it's a real plan enum value
    if (Object.values(Plan_Type_Enum).includes(plan)) {
      return plan as Plan_Type_Enum;
    }

    return null;
  } catch {
    return null;
  }
};

export const clearPlanPreference = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Silently ignore
  }
};
